
























import Vue from 'vue'
import { downloadFile, humanReadableFileSize } from '@/helper/fileHandler'
import BaseIcon from '../svgicons/BaseIcon.vue'
export default Vue.extend({
  props: {
    file: Object
  },
  components: {
    BaseIcon
  },
  data() {
    return {
      fileNameLimit: 20
    }
  },
  computed: {
    trimmedFileName(): string {
      if (this.file && this.file.title && this.file.title.length > this.fileNameLimit) {
        return `${this.file.title.substring(0, this.fileNameLimit)}...`
      }
      return this.file.title
    }
  },
  methods: {
    async downloadMaterial(url: string, title: string) {
      await downloadFile(url, title)
    },
    convertFileSize(size: number): string {
      return humanReadableFileSize(size)
    }
  }
})
